import _ from 'lodash';
import store from 'state/store/configureStore';
import moment from 'moment';
import { getToken } from './token.service';
import { setIsProcessingRepos } from 'state/actions';
import BrowserStorageAccessor from '../utils/BrowserStorageAccessor';
import { LOCAL_STORAGE_KEYS } from '../constants/constants';
import { PROJECT_STATUS } from '@linearb/linjs-common';
import { isReposFinishedProccesingSelector } from 'state/selectors/repositories';

export const shouldStopProjectStatesRecall = projects => {
  const shouldStopBasedOnState = projects.every(
    project => project.status === PROJECT_STATUS.STEADY
  );
  if (shouldStopBasedOnState) {
    return true;
  }
  const lastEditedTime = _.chain(projects)
    .map(({ editTime }) => editTime)
    .filter(Boolean)
    .orderBy(moment, 'descending')
    .first()
    .value();

  return (
    !lastEditedTime ||
    moment().utc().subtract(1, 'hour').isBefore(lastEditedTime)
  );
};

export const shouldStopOnboardingRecall = () =>
  !getToken() ||
  !!_.get(store.getState(), 'organization.finish_on_boarded_at', false);

export const shouldStopGetReposRecall = () => {
  const lastAddReposTimestamp = BrowserStorageAccessor().local.get(
    LOCAL_STORAGE_KEYS.FETCH_REPOS_TIMESTAMP
  );

  // waiting one minute for the job to start processing
  const oneMinBeforeNow = moment().subtract(1, 'minute').toISOString();

  if (lastAddReposTimestamp) {
    const isAfter = moment(lastAddReposTimestamp).isAfter(oneMinBeforeNow);
    if (isAfter) {
      return false;
    }
  }

  // limiting the time of polling to 2 hours
  const isInPollingTimeRange = moment(lastAddReposTimestamp).isBetween(
    moment().subtract(2, 'hour'),
    moment()
  );

  if (!isInPollingTimeRange) {
    store.dispatch(setIsProcessingRepos(false));
    BrowserStorageAccessor().local.remove(
      LOCAL_STORAGE_KEYS.FETCH_REPOS_TIMESTAMP
    );
    return true;
  }

  if (isReposFinishedProccesingSelector(store.getState())) {
    BrowserStorageAccessor().local.remove(
      LOCAL_STORAGE_KEYS.IS_PROCESSING_REPOS
    );
    store.dispatch(setIsProcessingRepos(false));
    return true;
  }
  return false;
};
